import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleRecommenderConfigLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleRecommenderConfig } = await import("@workflows/bundles/configurations/recommender-config");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_RECOMMENDER_CONFIG}>
      <BundleRecommenderConfig />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
